export default {
  seeUnarchivedCampaigns: 'Ver campanhas não arquivadas',
  seeArchivedCampaigns: 'Ver campanhas arquivadas',
  sendMassSms: 'Enviar um SMS em massa',
  mustChargeBeforeSendingCampaigns: 'Você deve recarregar antes de enviar campanhas',
  sendSmsCampaignFromFile: 'Enviar campanha de SMS a partir de um arquivo',
  createCampaign: 'Criar campanha',
  sendCampaignToDirectory: 'Enviar campanha para o seu Directório',
  forms: 'Formulários',
  unArchive: 'Unarchive',
  archive: 'Arquivo',
  loadingCampaigns: 'Campanhas de carregamento',
  noCampaignsCreated: 'Você não criou uma campanha',
  type: 'Tipo',
  status: 'Estado',
  campaignSuccessfullyArchived: 'Campanha corretamente arquivada',
  sendCampaign: 'Enviar campanha',
  shippingDateAndTime: 'Data e hora de envio',
  scheduleCampaign: 'Programação da campanha',
  campaignReadyAndWaitingToBeSent: 'A sua campanha está pronta e à espera de ser enviada',
  schedule: 'Programa',
  export: 'Exportação',
  campaignStatus: 'Estado da campanha',
  campaignScope: 'Âmbito da campanha',
  messagesToBeSent: 'Mensagens a serem enviadas',
  thisValueCouldChange: 'Este valor pode mudar',
  finalValue: 'Valor final',
  sendingDate: 'Data de envio',
  campaignProgress: 'Progresso da campanha',
  moreCounters: 'Mais balcões',
  lessCounters: 'Menos balcões',
  importingPeopleProgress: 'Progresso na importação de pessoas',
  importedPeople: 'Pessoas importadas',
  peopleAmount: 'Número total de pessoas',
  importingErrors: 'Erros de importação',
  sending: 'Ao enviar',
  sent: 'Enviados | Enviados | Enviados',
  onStandBy: 'Em standby',
  onDraft: 'No rascunho',
  scheduled: 'Programado',
  all: 'Todos',
  pending: 'Pendente',
  deliveredToCarrier: 'Entregue ao transportador',
  rejected: 'Rejeitado : Rejeitado',
  postponed: 'Adiado | Diferido',
  hardRebound: 'Rebounding strong | Rebounding strong',
  softRebound: 'Soft Rebound : Soft Rebound',
  opened: 'Abrir | Abrir',
  inSpam: 'Em spam',
  terminated: 'Rescisão : Rescisão',
  inBlackList: 'Colocado na lista negra',
  inWhiteList: 'Em lista branca',
  messagePart: 'Parte da mensagem | Partes da mensagem',
  delivered: 'Entregue em',
  importMorePeople: 'Importar mais pessoas',
  loadingUsers: 'Carregando usuários',
  clicked: 'Clique em',
  multiParts: 'Múltiplas partes',
  seeMessage: 'Ver mensagem',
  noUserDefinedMessage: 'O usuário não tem uma mensagem definida',
  youAreSeeingTheMessageOf: 'Você está olhando para a mensagem de',
  nameOfTheMassSms: 'Nome do SMS em massa',
  insertMassSmsKeyName: 'Digite um nome para ajudar a lembrar do que se trata este SMS em massa',
  noFilePicked: 'Você não selecionou um arquivo',
  downloadFormat: 'Formato de download',
  prepareMassSms: 'Preparar SMS em massa',
  insertMassSmsName: 'Digite o nome do SMS em massa',
  mustPickSmsFile: 'Você deve selecionar o arquivo do SMS',
  campaignSuccessfullyCreated: 'Campanha criada corretamente',
  campaignName: 'Nome da campanha',
  insertMassCampaignKeyName: 'Digite um nome para ajudar a lembrar do que se trata esta campanha',
  campaignType: 'Tipo de campanha',
  pickCampaignType: 'Selecione o tipo de campanha',
  writeYourMessageHere: 'Escreva aqui a sua mensagem...',
  pickPeopleList: 'Selecione uma lista de pessoas',
  pickOrCreateListOfPeopleToCommunicateMessage: 'Seleccione a lista de pessoas a quem pretende comunicar a sua mensagem ou criar uma nova lista, importando-as de um ficheiro externo.',
  allPeople: 'Todas as pessoas',
  waitWhileTheListGetsCreated: 'Espere enquanto a lista está sendo criada',
  noPeopleListPicked: 'Você não selecionou uma lista de pessoas',
  addYourFirstCondition: 'Adicione a sua primeira condição',
  addAnotherCondition: 'Acrescentar outra condição',
  attributeCondition: 'Condição de Atributo',
  actionCondition: 'Condição de ação',
  segmentPeopleByAttributesAndActions: 'Você pode segmentar as pessoas que interagem com sua empresa, seja por seus atributos, seja por ações realizadas dentro de sua plataforma.',
  youAreAlmostDone: 'Você está quase terminando!',
  yourMessageScope: 'A sua mensagem chegará às pessoas {númeroOdasPessoas}.',
  prepareCampaign: 'Preparar a campanha',
  insertMessageSubject: 'Digite o assunto da sua mensagem',
  insertMessageHtml: 'Digite o html da sua mensagem',
  createHtmlTemplate: 'Crie o seu modelo',
  importPeople: 'Importação de pessoas',
  insertCampaignName: 'Digite o nome da campanha',
  insertCampaignType: 'Entrar no tipo de campanha',
  subject: 'Assunto',
  insertHtmlTemplate: 'Criar modelo',
  previewTemplate: 'Preview Template',
  customize: 'Personalizar',
  from: 'A partir de',
  until: 'Para',
  attribute: 'Atributo',
  contains: 'Contém',
  noContains: 'Não contém',
  is: 'É',
  isNot: 'não é',
  addANameToYourTemplate: 'Adicione um nome ao seu modelo',
  templateName: 'Nome do modelo',
  save: 'Salve',
  // Triggers
  triggers: 'Gatilhos',
  noTitle: 'Sem título',
  loadingTriggers: 'Carregamento de gatilhos',
  noRegisteredTriggers: 'Sem gatilhos registados',
  title: 'Título',
  executeTriggerWhenActionFire: 'Executar o gatilho quando é uma ação',
  customActionToFilter: 'Ação personalizada a ser filtrada',
  actionsToExecute: 'Ações a serem executadas',
  emailBody: 'Corpo do e-mail',
  smsBody: 'Corpo do SMS',
  postRequestData: 'Dados de pedido POST',
  saveTrigger: 'Salvar Gatilho',
  trigger: 'Gatilho',
  new: 'Novo',
  edit: 'Editar',
  add: 'Adicione',
  triggerDetails: 'Detalhes do gatilho',
  triggerScope: 'Alcance do gatilho',
  editTrigger: 'Editar gatilho',
  createTrigger: 'Criar gatilho',
  triggerSuccessfullyCreated: 'Gatilho criado com sucesso',
  triggerSuccessfullyUpdated: 'Gatilho atualizado com sucesso',
  launchers: 'Lançadores',
  actionType: 'Ação {ação}',
  addNotification: 'Adicionar notificação',
  notifications: 'Notificações',
  loadingNotifications: 'Notificações de carga',
  noNotificationsCreated: 'Nenhuma notificação criada',
  newNotification: 'Nova notificação',
  notificationCreatedSuccessfully: 'Notificação criada corretamente',
  editNotification: 'Editar notificação',
  notificationEditedSuccessfully: 'Notificação corretamente editada',
  youDontHaveNotifications: 'Você não tem notificações',
  invalidFileType: 'Tipo de arquivo inválido',
  noDataFound: 'Não foram encontrados dados',
  clickOnYourFileTypeOrDragHere: 'Clique no seu tipo de arquivo ou arraste-o aqui',
  filesSize: 'Arquivos maiores que 5 Mbs não são suportados',
  findQuickAnswer: 'Procure uma resposta rápida',
  noAnswerFound: 'Não encontrámos a resposta que procura.',
  titleNewInformation: 'Título da nova informação',
  waitingForAttention: 'À espera de atenção',
  terminationReason: 'Motivo da conclusão',
  findTerminationReason: 'Encontrar motivo de rescisão',
  nameless: 'Sem nome',
  conversationClassification: 'Classificação das conversas',
  withoutAdvisor: 'Nenhum conselheiro',
  you: 'Você',
  agents: 'Agentes',
  advisors: 'Conselheiros',
  conversations: 'Conversas',
  host: 'Anfitrião',
  attended: 'Atendido',
  noAttended: 'Sem supervisão',
  responseTime: 'Tempo de resposta',
  noAttendedConversations: 'Conversas desacompanhadas',
  attendedConversations: 'Conversas assistidas',
  totalConversations: 'Total de conversações',
  lastMonth: 'Último mês',
  phone: 'Celular',
  organic: 'Orgânico',
  conversationsPerChannel: 'Conversas por canal',
  createdPeople: 'Pessoas criadas',
  waitTime: 'Tempo de espera',
  yesterday: 'Dia anterior',
  withBot: 'Com bot',
  assignTaskAfterSettingJourney: 'Atribuir tarefa após atribuir o status de Journey',
  pickAJourneyStatus: 'Selecione o estado da Viagem',
  journeys: 'Jornadas',
  timeInMinutesToCreateTaskAfterSettingJourney: 'Tempo em minutos para criar tarefa depois de atribuir Journey',
  untrainedQuestions: 'Perguntas sem formação',
  numberOfQuestions: 'Número de perguntas',
  serviceRating: 'Qualificação do serviço',
  usersWhoGotProactivity: 'Utilizadores que se tornaram pró-activos',
  bot: 'Robô',
  questions: 'Perguntas',
  operator: 'Operador',
  time: 'tiempo',
  attendedAndUnansweredConversations: 'Conversas atendidas e não atendidas',
  total: 'Total',
  pickExtraData: 'Escolha dados extras',
  pickExtraDataFieldAndValue: 'Escolha campo de dados e valor extras',
  writeExtraDataValue: 'Escreva valor de dados extra',
  campaignInformation: 'Informação da campanha',
  // Trigger to do list translations
  smsToUser: 'SMS para o usuário',
  emailToUser: 'E-mail para o usuário',
  postRequestToServer: 'Postar solicitação para o servidor',
  createTaskForUser: 'Criar tarefa para o usuário',
  // Trigger action types translations
  ACTION_CUSTOM: 'Ação personalizada',
  ACTION_REGISTER_EMAIL: 'No registro de e-mail',
  ACTION_REGISTER_PHONE: 'No registro do telefone',
  ACTION_REGISTER_VERIFIED: 'No registro verificado',
  ACTION_REGISTER_EMAIL_RESEND: 'No reenvio do e-mail de registro',
  ACTION_REGISTER_SOCIAL: 'No registro com redes sociais',
  ACTION_REGISTER_GOOGLE: 'E-mail para o usuário0',
  ACTION_REGISTER_FACEBOOK: 'E-mail para o usuário1',
  ACTION_REGISTER_SPOTIFY: 'E-mail para o usuário2',
  ACTION_REGISTER_INSTAGRAM: 'E-mail para o usuário3',
  ACTION_REGISTER_APPLEID: 'E-mail para o usuário4',
  ACTION_REGISTER_EMAIL_FAIL: 'E-mail para o usuário5',
  ACTION_REGISTER_PHONE_FAIL: 'E-mail para o usuário6',
  ACTION_LOGIN_EMAIL: 'E-mail para o usuário7',
  ACTION_LOGIN_PHONE: 'E-mail para o usuário8',
  ACTION_LOGIN_SOCIAL: 'E-mail para o usuário9',
  ACTION_LOGIN_GOOGLE: 'Postar solicitação para o servidor0',
  ACTION_LOGIN_FACEBOOK: 'Postar solicitação para o servidor1',
  ACTION_LOGIN_INSTAGRAM: 'Postar solicitação para o servidor2',
  ACTION_LOGIN_SPOTIFY: 'Postar solicitação para o servidor3',
  ACTION_LOGIN_APPLEID: 'Postar solicitação para o servidor4',
  ACTION_LOGIN_MAIL_ONE_TIME_PASSWORD: 'Postar solicitação para o servidor5',
  ACTION_LOGIN_MAIL_ONE_TIME_PASSWORD_FAIL: 'Postar solicitação para o servidor6',
  ACTION_LOGIN_PHONE_ONE_TIME_PASSWORD: 'Postar solicitação para o servidor7',
  ACTION_LOGIN_PHONE_ONE_TIME_PASSWORD_FAIL: 'Postar solicitação para o servidor8',
  ACTION_LOGIN_EMAIL_FAIL: 'Postar solicitação para o servidor9',
  ACTION_LOGIN_EMAIL_FAIL_USER: 'Criar tarefa para o usuário0',
  ACTION_LOGIN_EMAIL_FAIL_AUTHS: 'Criar tarefa para o usuário1',
  ACTION_LOGIN_EMAIL_FAIL_WRONG_PSW: 'Criar tarefa para o usuário2',
  ACTION_LOGIN_PHONE_FAIL: 'Criar tarefa para o usuário3',
  ACTION_LOGIN_PHONE_FAIL_USER: 'Criar tarefa para o usuário4',
  ACTION_LOGIN_PHONE_FAIL_AUTHS: 'Criar tarefa para o usuário5',
  ACTION_LOGIN_PHONE_FAIL_WRONG_PSW: 'Criar tarefa para o usuário6',
  ACTION_RESET_PASSWORD_PHONE: 'Criar tarefa para o usuário7',
  ACTION_RESET_PASSWORD_EMAIL: 'Criar tarefa para o usuário8',
  ACTION_RESET_VALIDATION: 'Criar tarefa para o usuário9',
  ACTION_RESET_OTP: 'Ação personalizada0',
  ACTION_LOGOUT: 'Ação personalizada1',
  ACTION_SUBMIT: 'Ação personalizada2',
  ACTION_SUBMIT_FILE: 'Ação personalizada3',
  ACTION_USER_IMAGE: 'Ação personalizada4',
  ACTION_EVENT_PURCHASE: 'Ação personalizada5',
  ACTION_EVENT_PURCHASE_CONFIRMATION: 'Ação personalizada6',
  ACTION_USER_CHANGE: 'Ação personalizada7',
  ACTION_ON_JOURNEY_SET: 'Ação personalizada8',
  ACTION_ON_EXTRADATA_FIELD_CHANGE: 'Ação personalizada9',
  ACTION_ON_EXTRADATA_VALUE_CHANGE: 'No registro de e-mail0',
  attachFiles: 'Anexar arquivos',
  attachFilesInCampaignDescription: `
  Para anexar arquivos à sua campanha de e-mail,
  cada arquivo que você anexa pode pesar apenas 5 MB e o tamanho total dos arquivos
  deve pesar menos que {size} {units}.
  `,
  sizeOfFileCantExceed: 'O tamanho de cada arquivo não pode exceder {size} {units}',
  filesTotalSizeMustBeSmallerThan: 'O tamanho total dos seus arquivos não pode exceder {size} {units}',
  attachedFiles: 'Arquivos anexados',
  fileSuccessfullyDeleted: 'Arquivo excluído com sucesso',
  fileWithSameNameAlreadyExists: 'Já existe um arquivo com o mesmo nome',
  filesSuccessfullyAttached: 'Arquivo anexado com sucesso'
}
